@if (!hidden()) {
  <button #fab type="button"
    class="tw-fixed tw-z-fab tw-w-10 tw-h-10 tw-min-w-0 tw-p-0 !tw-m-0 tw-rounded-full tw-shadow-z9 tw-flex tw-items-center tw-justify-center tw-bg-teal-600 tw-select-none tw-touch-none"
    [class.tw-transition-all]="snapping()"
    [class.tw-duration-200]="snapping()"
    [style.left.px]="posX()"
    [style.top.px]="posY()"
    (pointerdown)="onPointerDown($event)">
    <img src="https://cdn.cureskin.com/app/img/ai-star.svg" class="tw-w-5 tw-h-5 tw-pointer-events-none tw-brightness-0 tw-invert" alt="AI chat" />
  </button>

  @if (isMoving()) {
    <div
      class="tw-fixed tw-left-1/2 tw--translate-x-1/2 tw-bottom-8 tw-z-trash tw-w-14 tw-h-14 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-pointer-events-none tw-shadow-z9 tw-transition-transform tw-duration-150"
      [class.tw-scale-125]="overCross()"
      [class.tw-bg-gray-400]="overCross()"
      [class.tw-bg-gray-200]="!overCross()">
      <i class="cs-icon-close tw-text-teal-600 tw-text-650 tw-pointer-events-none"></i>
    </div>
  }
}
